<template>
  <div class="produit" transition="slide-x-transition" v-if="dose > 0">
    <div class="produit-dose">
      <v-img :src="imageSrc" contain position="left center" alt="image produit" class="img__produit" height="22"></v-img>
      <div class="dose">{{ dose }} {{ $t("kgha") }}</div>
    </div>
    <div class="produit__compo">
      <span v-html="compoString"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Produit",
  data: function() {
    return {
      etat: null
    };
  },
  computed: {
    imageSrc() {
      return `img/${this.image}.svg`;
    },

    compoString() {
      let compoString = "";
      const arrayCompo = Object.entries(this.compo);
      let index = 0;
      arrayCompo.forEach(elem => {
        compoString += compoString.length > 0 && elem[1] !== 0 ? " | " : "";
        compoString +=
          elem[1] === 0 ? "" : ` ${this.$i18n.t(elem[0])} ${this.$options.filters.numLocal(elem[1])}% `;
      }, index);
      return compoString;
    }
  },
  props: {
    image: String,
    dose: Number,
    compo: Object
  }
};
</script>

<style scoped lang="scss">
.produit {
  display: flex;
  flex-flow: column;

  & + .produit {
    margin-top: -0.5em;
  }
}

.img__produit {
  width: 110px;
}

.produit-dose {
  display: flex;
  flex-flow: row nowrap;
  align-items:center;
}

.dose {
  width: calc(100% - 120px);
}

.produit__compo span {
  display: block;
  font-size: 0.8em;
  margin-top: 0;
  margin-bottom: 1em;
}
</style>
